// extracted by mini-css-extract-plugin
module.exports = {"Topic":"Topic-27lfNa1f"};